module.exports = __webpack_public_path__ + "static/media/1976.f5338e36.jpg";